import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { ModalDirective } from 'ngx-bootstrap';

import { Column, Contract, DatatableButton } from 'app/models';
import { ContractService } from 'app/services';

@Component({
  selector: 'app-admin-contracts',
  templateUrl: './admin-contracts.component.html',
  styleUrls: ['./admin-contracts.component.scss']
})
export class AdminContractsComponent implements OnInit {
  @ViewChild('confirmRemoveContractDialog') confirmRemoveContractDialog: ModalDirective;

  public columns: Column[] = [
    { property: 'prefix', label: 'CONTRACTS.PREFIX', type: 'string' },
    { property: 'name', label: 'CONTRACTS.NAME', type: 'string' },
    { property: 'contractType', label: 'CONTRACTS.CONTRACTTYPE', type: 'string' }
  ];

  public buttons: DatatableButton[] = [
    {
      id: 'trash',
      action: this.prepareRemoveContract.bind(this),
      showIf: data => true,
      label: '',
      icon: 'trash',
      classes: 'btn btn-primary'
    }
  ];

  public contracts: Contract[] = [];
  public contractToRemove: Contract;

  constructor(private readonly router: Router, private readonly contractService: ContractService) {}

  public ngOnInit() {
    this.getContracts();
  }

  prepareRemoveContract(contract: Contract) {
    this.contractToRemove = contract;
    this.confirmRemoveContractDialog.show();
  }

  public stopRemoveContract(): void {
    this.contractToRemove = null;
    this.confirmRemoveContractDialog.hide();
  }

  removeContract() {
    this.contractService.deleteContract(this.contractToRemove.id).subscribe(removedContract => {
      this.stopRemoveContract();
      this.getContracts();
    });
  }

  private getContracts() {
    this.contractService.getContracts().subscribe(contracts => {
      this.contracts = contracts ? contracts : [];
    });
  }

  goToNewContractPage() {
    this.router.navigate(['/admin/contracts/new']);
  }

  goToContractDetailPage(contract: Contract) {
    this.router.navigate([`/admin/contracts/detail/${contract.id}`]);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/contracts/admin-contracts.component.ts